/** The legal documents (/legal/:doc), one file each; loaded with the legal page only (i18n/legalDocs.ts). */
import terms from "./terms";
import refunds from "./refunds";
import payouts from "./payouts";
import prohibited from "./prohibited";
import aml from "./aml";
import privacy from "./privacy";
import cookies from "./cookies";
import risk from "./risk";
import execution from "./execution";

export default {
  terms,
  refunds,
  payouts,
  prohibited,
  aml,
  privacy,
  cookies,
  risk,
  execution,
} as const;
